var React = require('react');

function Moon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"}));
}

Moon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-moon"};

module.exports = Moon;

Moon.default = Moon;
